var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateTimeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.224 5.06738H12.7757C7.74065 5.06738 4.58398 8.63238 4.58398 13.6774V27.2907C4.58398 32.3357 7.72398 35.9007 12.7757 35.9007H27.2223C32.274 35.9007 35.4173 32.3357 35.4173 27.2907V13.6774C35.4173 8.63238 32.274 5.06738 27.224 5.06738Z",
    stroke: "#0077CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.6517 23.847L20 20.4754V13.207",
    stroke: "#0077CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTimeIcon);
export default __webpack_public_path__ + "static/media/date-time-icon.22807eb722d8b5c2a4496870318bbcb1.svg";
export { ForwardRef as ReactComponent };